import $ from 'jquery';
const toastDelay = 8000;
// show toast if message exist
if ($('#globalToast .toast-text').text().trim().length > 0) {
    $('#globalToast').toast({
        delay: toastDelay
    }).toast('show');
}

export const showToast = (type: 'success' | 'danger', message: string) => {
    $('#globalToast .toast-text').text(message);
    $('#globalToast').removeClass("is-success").removeClass("is-danger");

    $('#globalToast').addClass(`toast-${type}`);

    $('#globalToast').toast({
        delay: toastDelay
    }).toast('show');
}

export default undefined;